import { fontSizes, pxToRem } from "./buyFlowTextStyles";
import { addOpacityToColor, colours } from "./colours";
import { mediaQuery } from "./deviceDimensions";

export const AddressType = {
	POBox: "P.O. Box",
	ParcelLocker: "ParcelLocker",
	HomeApartment: "HomeApartment",
};

export const streetTypeOptions = [
	{ value: "None", label: "None " },
	{ value: "Ally", label: "Alley" },
	{ value: "Arc", label: "Arcade" },
	{ value: "Ave", label: "Avenue" },
	{ value: "Bvd", label: "Boulevard" },
	{ value: "Bypa", label: "Bypass" },
	{ value: "Cct", label: "Circuit" },
	{ value: "Cl", label: "Close" },
	{ value: "Crn", label: "Corner" },
	{ value: "Ct", label: "Court" },
	{ value: "Cres", label: "Crescent" },
	{ value: "Cds", label: "Cul-de-sac" },
	{ value: "Dr", label: "Drive" },
	{ value: "Esp", label: "Esplanade" },
	{ value: "East", label: "East" },
	{ value: "Grn", label: "Green" },
	{ value: "Gr", label: "Grove" },
	{ value: "Hwy", label: "Highway" },
	{ value: "Jnc", label: "Junction" },
	{ value: "Lane", label: "Lane" },
	{ value: "Link", label: "Link" },
	{ value: "Mews", label: "Mews" },
	{ value: "Pde", label: "Parade" },
	{ value: "Pl", label: "Place" },
	{ value: "Rdge", label: "Ridge" },
	{ value: "Rd", label: "Road" },
	{ value: "Sq", label: "Square" },
	{ value: "St", label: "Street" },
	{ value: "Tce", label: "Terrace" },
	{ value: "West", label: "West" },
];

export const stateTerritoryOptions = [
	{ value: "ACT", label: "Australian Capital Territory" },
	{ value: "NSW", label: "New South Wales" },
	{ value: "NT", label: "Northern Territory" },
	{ value: "QLD", label: "Queensland" },
	{ value: "SA", label: "South Australia" },
	{ value: "TAS", label: "Tasmania" },
	{ value: "VIC", label: "Victoria" },
	{ value: "WA", label: "Western Australia" },
];

const largeTextStyles = {
	color: colours.MIDNIGHT_BLUE,
	fontFamily: "var(--euclid-regular)",
	fontSize: pxToRem(fontSizes.mobile.LARGE),
	lineHeight: "1.35em",

	[mediaQuery.tabletAndUp]: {
		fontSize: pxToRem(fontSizes.tablet.LARGE, "tablet"),
	},
};

const baseTextStyles = {
	color: colours.MIDNIGHT_BLUE,
	fontFamily: "var(--euclid-regular)",
	fontSize: pxToRem(fontSizes.mobile.BASE),
	lineHeight: "1.35em",

	[mediaQuery.tabletAndUp]: {
		fontSize: pxToRem(fontSizes.tablet.BASE, "tablet"),
	},
};

const BORDER_RADIUS = "0.75rem";

export const sharedSelectStyle = {
	container: (provided) => ({
		...provided,
		width: "100%",
	}),
	input: (provided) => ({
		...provided,
		...largeTextStyles,
		margin: "0",
		padding: "0",
		fontFamily: "var(--euclid-medium)",
		caretColor: colours.PEACH,
		height: "100%",
		width: "100%",

		display: "flex",
		flexDirection: "row",
		alignItems: "center",
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0",
		height: "100%",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
	}),
	singleValue: (provided) => ({
		...provided,
		...largeTextStyles,
		margin: "0",
		padding: "0",
		display: "block",
	}),
	placeholder: (provided, state) => ({
		...provided,
		...largeTextStyles,
		opacity: state.isFocused ? 0.33 : 0,
		color: colours.MIDNIGHT_BLUE,
	}),

	menu: (provided) => ({
		...provided,
		margin: "0",
		boxShadow: `0 0.25rem 1rem ${addOpacityToColor(colours.SHADOW, 0.18)}`,
		borderRadius: `0 0 ${BORDER_RADIUS} ${BORDER_RADIUS}`,
	}),
	menuList: (provided) => ({
		...provided,
		margin: 0,
		padding: 0,
	}),
	option: (provided, { isSelected }) => ({
		...provided,
		...baseTextStyles,

		fontFamily: isSelected ? "var(--euclid-medium)" : "var(--euclid-regular)",
		backgroundColor: "inherit",
		padding: "0.5rem 1.25rem",

		":hover": {
			backgroundColor: colours.PALE_PEACH,
		},

		":last-child:hover": {
			borderRadius: `0 0 ${BORDER_RADIUS} ${BORDER_RADIUS}`,
		},
	}),
};
